/**
 * Утилиты для валидации email-адресов.
 */
export class EmailChecker {
  errorMessage: string = 'Адрес электронной почты введен не корректно.';

  /**
   * Проверяет email на корректность
   * @param email - строка адреса электронной почты
   * @returns {boolean}
   */
  checkEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z0-9]{2,}$/;

    if (!emailRegex.test(email)) {
      return false;
    }

    // Разделяем на локальную часть и домен
    const parts = email.split('@');
    if (parts.length !== 2) {
      return false;
    }

    const localPart = parts[0];
    const domain = parts[1];

    // Запрещаем точку в начале и конце локальной части
    if (localPart.startsWith('.')) {
      return false;
    }
    if (localPart.endsWith('.')) {
      return false;
    }

    // Запрещаем две точки подряд в локальной части
    if (localPart.includes('..')) {
      return false;
    }

    // Запрещаем точку в начале и конце домена
    if (domain.startsWith('.')) {
      return false;
    }
    if (domain.endsWith('.')) {
      return false;
    }

    // Запрещаем две точки подряд в домене
    if (domain.includes('..')) {
      return false;
    }

    return true;
  }


  checkEmailsList(email: string, max_count: number): boolean {
    if (isNaN(max_count) || max_count === undefined) max_count = 0
    // Хранилище списка почт.
    const emailsList = [];
    if (!max_count || max_count <= 1) {
      // Если максимальное количество почт = 0 (не передано) или 1, просто берем почту, как есть,
      // если там указали несколько почт - валидацию не пройдёт запятая.
      return this.checkEmail(email.trim())
    } else {
      // Если максимальное количество почт указано более 1, делим запятой и собираем в список.
      email.split(',').map(function (el) {
        emailsList.push(el.trim())
      })
      // Если количество почт превышает максимальное - валидация не пройдена.
      if (emailsList.length > max_count) return false
    }

    for (let i = 0; i < emailsList.length; i++) {
      // В цикле обходим список почт и проверяем работающим регулярным выражением кадый адрес.
      const el = emailsList[i]

      if (!this.checkEmail(el)) {
        return false;
      }
    }

    return true;
  }
}
